module.exports = require("./sbp.d.ts");